var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPump({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C6 0.895431 6.89543 0 8 0C9.10457 0 10 0.895431 10 2C10 3.10457 9.10457 4 8 4C6.89543 4 6 3.10457 6 2ZM2 8C2 6.34315 3.34315 5 5 5H11C12.6569 5 14 6.34315 14 8V21H15C15.5523 21 16 21.4477 16 22C16 22.5523 15.5523 23 15 23H1C0.447715 23 0 22.5523 0 22C0 21.4477 0.447715 21 1 21H2V8ZM4 21H12V8C12 7.44772 11.5523 7 11 7H5C4.44772 7 4 7.44772 4 8V21ZM5 9C5 8.44772 5.44772 8 6 8H10C10.5523 8 11 8.44772 11 9V13C11 13.5523 10.5523 14 10 14H6C5.44772 14 5 13.5523 5 13V9ZM7 10V12H9V10H7ZM16 8C16.5523 8 17 8.44772 17 9V16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16V9C15 8.44772 15.4477 8 16 8Z",
    fill: "#8B8C90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPump);
export default __webpack_public_path__ + "static/media/Pump.53a6b524.svg";
export { ForwardRef as ReactComponent };